module.exports = __webpack_public_path__ + "static/projekt_indywidualny_d02-42a0ed9f823c89dd819d3e6f82cc0622.jpg";